
import Vue, { PropType } from "vue";
import { DialogCloseType, DialogI } from "@/types/dialog";
import BaseDialog from "@/components/dialog/BaseDialog.vue";
import Btn from "@/components/v2/base/Btn.vue";
import { prefersDarkTheme, themeState } from "@/utils/theme";

// Asked once, right after the first use of the quick dark-mode switch: keep switching by hand, or follow
// the phone's / computer's own setting from now on.
export default Vue.extend({
  name: "ThemeFollowDeviceDialog",
  components: { BaseDialog, Btn },
  props: {
    dialog: {
      type: Object as PropType<DialogI>,
      required: true,
    },
  },
  computed: {
    deviceDark(): boolean {
      return themeState.systemDark;
    },
    // Following the device right now would undo the switch the user just made — say so up front.
    deviceDiffers(): boolean {
      return this.deviceDark !== prefersDarkTheme();
    },
  },
  methods: {
    answer(followDevice: boolean) {
      this.dialog.close({ type: DialogCloseType.SUBMITTED, payload: { followDevice } });
    },
  },
});
